import { FormProvider } from "react-hook-form";

import {
  ContactsDirectoryForUpdate,
  useContactsDirectory,
} from "../modules/contactsDirectory";

export const DirectoryCategoriesByIdPage = () => {
  const { formMethodsUpdate } =
    useContactsDirectory();
  return (
    <>
      <FormProvider {...formMethodsUpdate}>
        <ContactsDirectoryForUpdate />
      </FormProvider>
    </>
  );
};
